// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2t6aB","questions":"styles_questions__1CfTr","footer":"styles_footer__3Oe6z"};